module.exports = __webpack_public_path__ + "static/media/341671_06big.f23a231b.jpg";